import 'styleguide/styleguide-critical/critical-affiliate-widget';

import $ from 'jquery';
import customPaging from 'styleguide/modules/slick/custom-paging';
import 'styleguide/modules/slick-slider';
import 'styleguide/modules/horizontal-scroll';

window.$ = $;
window.jQuery = $;

$(document).ready(() => {
  // SVG support & Ajax SVG defs sprite
  var supportsSvg = function () {
    var div = document.createElement('div');
    div.innerHTML = '<svg/>';
    return (div.firstChild && div.firstChild.namespaceURI) ==
      'http://www.w3.org/2000/svg';
  };
  if (supportsSvg()) {
    // Inline SVG is supported so Ajax for the sprite.
    var ajax = new XMLHttpRequest();
    ajax.open("GET",
      "https://is4.revolveassets.com/r/r_src/mobile/styleguide/lib/sprite.svg",
      true);
    ajax.send();
    ajax.onload = function (e) {
      if (this.getResponseHeader("Content-Type") === "image/svg+xml") {
        var div = document.createElement("div");
        div.innerHTML = ajax.responseText;
        div.id = "svg-sprites";
        document.body.insertBefore(div, document.body.childNodes[0]);
      }
    }
  }

  function mobileInit() {
    $('.js-horizontal-scroll').horizontalScroll();
  }
  
  function desktopInit() {
    $('.js-affiliate-widget-carousel').slickSlider({
      dots: true,
      customPaging,
      dotsClass: "image-carousel__dots",
      appendDots: $(".image-carousel__dots-container--centered"),
      slidesToShow: 8,
      slidesToScroll: 8,
      responsive: [{
        breakpoint: 1027,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      }]
    });
  }

  function parseRtn(rtn){
    return JSON && JSON.parse(rtn) || $.parseJSON(rtn);
  }

  $.ajax({
    type: 'GET',
    url: `/r/ajax/GetProductData.jsp${location.search}&largeImg=true`,
    success: function (data) {
      const products = {};
      const result = parseRtn(data)
      let templateHtml;
      const touchDevice = ('ontouchstart' in document.documentElement);
      if (!touchDevice) {
        templateHtml = $('#template-product-item-main').html();
      } else {
        templateHtml = $('#template-product-item-mobile').html();
      }
      let listProducts = "";
      $.each(result, function (key, value) {
        const code = key;
        products[code] = value;
        const product = products[code];
        listProducts += templateHtml
            .replace(/{{name}}/g, product.name)
            .replace(/{{brand}}/g, product.brand)
            .replace(/{{widgetShareLink}}/g, product.widgetShareLink)
            .replace(/{{price}}/g, product.price)
            .replace(/{{imgPlp}}/g, product.imgPlp);
      })
      if (!touchDevice) {
        $('#js-affiliate-widget-carousel').html(listProducts);
        desktopInit();
      } else {
        $('#js-affiliate-widget-scroll').html(listProducts);
        mobileInit();
      }
    }
  });

});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/styleguide-critical/affiliate-widget.js